import styled from 'styled-components';
import { colors, layout } from '@prisjakt/ui-base';

export const AlertPrice = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0;
  flex: 1;
  justify-content: space-between;
`;

export const LightText = styled.span`
  font-weight: normal;
  color: ${colors.darkGray2};
`;

export const AlertTimeText = styled(LightText)`
  white-space: nowrap;
  font-size: ${layout.fontSizes.small.desktop.rem};
  font-style: italic;
`;

type PriceChangeProps = {
  up: boolean;
};

export const PriceChange = styled.span<PriceChangeProps>`
  font-weight: bold;
  color: ${p => (p.up ? colors.darkGray2 : colors.green1)};
  margin-right: 5px;
  font-size: ${layout.fontSizes.small.desktop.rem};
`;
